var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:[
    'rounded-md p-6 flex gap-3 items-center transition-all',
    _vm.variantClasses,
    _vm.customClass
  ]},[(_vm.icon)?_c(_vm.icon,{tag:"component",class:_vm.iconClasses,attrs:{"size":_vm.iconSize}}):_vm._e(),_c('div',{staticClass:"flex-1 min-w-0"},[(_vm.title)?_c('h4',{class:_vm.titleClasses},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('p',{class:_vm.messageClasses},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)]),(_vm.dismissible)?_c('button',{class:_vm.closeButtonClasses,attrs:{"aria-label":"Close alert"},on:{"click":_vm.handleDismiss}},[_c('X',{attrs:{"size":16}})],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }